import React, { Component } from 'react';
import { Row, Col, Input, Modal, Select, DatePicker, Checkbox, message, Spin } from 'antd';
import { getCookie } from '../../../hook';
import moment from 'moment';
import $ from 'jquery';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
class EditLeave extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible         : false,
            leave_id        : '',
            user_id         : 'none',
            leave_type_id   : 'none',
            from_date       : 'none',
            to_date         : 'none',
            reason          : 'none',
            company_id      : '',
            attachment      : '',
            unit            : 1,
            loader          : false,
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
        this.handleDate = this.handleDate.bind( this );
        this.handleAttachment = this.handleAttachment.bind( this );
    }

    handleAttachment( e ){
        var fdata = new FormData();
        let user = getCookie('dv_hrms_user').split(',');
        var user_id =  user[1];

        this.setState({ loader: true });

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "user_id", user_id );

            });
        }

        this.props.onUpload( fdata );
    }

    handleOk = (e) => {

        if( this.state.user_id === "" || this.state.user_id === "none" &&
            this.state.leave_type_id === "" || this.state.leave_type_id === "none" &&
            this.state.from_date === "" || this.state.from_date === "none" &&
            this.state.to_date === "" || this.state.to_date === "none" ){

            return false;

        }

        this.props.onSubmit( this.state );
        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    
    componentWillReceiveProps( nextProps ){

        if( nextProps.data.length !== 0 ){

            this.setState({
                leave_id        : nextProps.data.leave_id,
                user_id         : nextProps.data.user_id,
                leave_type_id   : nextProps.data.leave_type_id,
                from_date       : nextProps.data.from_date,
                to_date         : nextProps.data.to_date,
                reason          : nextProps.data.reason,
                employee        : nextProps.data.employee,
                company_id      : nextProps.data.company_id,
                approved        : nextProps.data.approved,
                attachment      : nextProps.data.attachment,
                unit            : nextProps.data.unit
            })

        }

        this.setState({
            visible: nextProps.onModel,
            attachment: nextProps.attachment,
            loader: false
        });

    }

    handleDate( date, dateString ){

        let isArr = Array.isArray( dateString )

        if( isArr === true ){
            this.setState({ from_date: dateString[0], to_date: dateString[1] })
        } else {
            this.setState({ from_date: dateString, to_date: dateString })
        }

    }

    render() {

        const list_leave_type = this.props.leave_type.map( ( item, i ) => 
            <Option key={ item.leave_type_id }>{ item.leave_type_name }</Option> )

        return (

            <Modal
                title="Edit Leave"
                maskClosable={ false }
                visible={ this.state.visible }
                okButtonProps={ ( this.state.approved === '1' ) ? {disabled: true} : {disabled: false}  }
                onOk={ this.handleOk }
                onCancel={ this.handleCancel } >

                <Row gutter={16} className="mrg_b_10">
                    <Col span={ 12 }>
                        <label>Employee</label>
                        <Input style={{ textTransform: 'Capitalize' }} value={ this.state.employee } disabled />
                    </Col>
                     <Col span={ 12 }>
                        <label>Unit</label>
                        <br />
                        <Select
                            value={ this.state.unit }
                            onChange={ (value)=>this.setState({ unit: value }) }
                            style={{ width: '100%' }}>
                            <Option value={ '1' }>Full Day</Option>
                            <Option value={ '0.5' }>Half Day</Option>
                        </Select>
                    </Col>
                </Row>

                <Row gutter={16} className="mrg_b_10">
                    <Col span={ 12 }>
                        <label>Leave Type</label>
                        <br />
                        <Select 
                            value={ this.state.leave_type_id }
                            onChange={ (value)=>this.setState({ leave_type_id: value }) }
                            placeholder="Select Leave Type"
                            style={{ width: '100%' }}>
                            { list_leave_type }
                        </Select>
                    </Col>
                    <Col span={ 12 }>
                        <label>From - To Date</label>
                        <br />

                        { ( this.state.unit === '1' ) ? 
                            <RangePicker 
                                value={[ moment( this.state.from_date , dateFormat ), moment( this.state.to_date, dateFormat )]}
                                onChange={ this.handleDate } style={{ width: '100%' }} /> : 
                            <DatePicker 
                                value={moment( this.state.from_date , dateFormat )}
                                onChange={ this.handleDate } style={{ width: '100%' }} /> }
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Reason for leave</label>
                        <TextArea 
                            value={ this.state.reason }
                            onChange={ ( e ) => this.setState({ reason: e.target.value }) } row={3} />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Attachment ( <em styel={{ fontSize: '8px', color: '#999' }}>If you have multiple files please zip and attach</em> )</label>
                        <Spin spinning={ this.state.loader }>
                            <input type="file" className={ ( this.state.attachment ) ? 'success': '' } onChange={ this.handleAttachment } />
                        </Spin>
                    </Col>
                </Row>

            </Modal>

        )
    }
}

export default EditLeave


// WEBPACK FOOTER //
// ./src/pages/leave/childs/edit.leave.js